import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

class Precanned extends React.Component {

	componentDidMount() {

		jQuery(jQuery("input.precanned.null")[0]).focus();
	}

	render() {

		var label_classes = "input input-primary label text-dark form-control";
		var label_input_group_classes = "input-group feedback-form-control mb-2 mt-3";
		var text_classes = "input input-primary textarea text placeholder-up text-dark form-control";
		var text_input_group_classes = "input-group feedback-form-control mt-3";
		if (this.props.precanned.label_error != null && this.props.precanned.label_error != false) {
			label_classes += " is-invalid";
			label_input_group_classes += " is-invalid";
		}

		if (this.props.precanned.text_error != null && this.props.precanned.text_error != false) {
			text_classes += " is-invalid";
			text_input_group_classes += " is-invalid";
		}

		return (
			<div className="col-sm-12">
				<div className="row precanned-item">
					<div className="precanned mb-sm-4 mb-2" id={this.props.precanned.id ?? null}>
						<div className={label_input_group_classes}>
							<input
								type="text"
								onChange={this.props.changeLabel.bind(this)}
								value={this.props.precanned.label}
								name={"label_" + (this.props.precanned.id ?? "new_" + this.props.uuid)}
								required
								className={label_classes + " precanned " + this.props.precanned.id}
								placeholder={__('Label')}
							/>
						</div>

						{this.props.precanned.label_error &&
							<label className="text-danger">{this.props.precanned.label_error}</label>
						}

						<div className={text_input_group_classes}>
							<textarea
								onChange={this.props.changeText.bind(this)}
								value={this.props.precanned.text}
								name={"text_" + (this.props.precanned.id ?? "new_" + this.props.uuid)}
								required
								className={text_classes}
								placeholder={__('Text')}
							>

							</textarea>
						</div>
						{this.props.precanned.text_error &&
							<label className="text-danger">{this.props.precanned.text_error}</label>
						}
					</div>
					<div className="d-flex align-items-center mb-4 justify-content-end justify-content-sm-center precanned-action">
						<a href="#" className="delete" onClick={this.props.delete.bind(this)}><i className="fas fa-times text-dark"></i></a>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return { state: state }
}

export default connect(mapStateToProps)(Precanned);
